import { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
export function MetaPixel() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return null;
}